import { useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import type { PracticeQueueRouteParams } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/types';
import {
	useInitFetchResource,
	useResourceWithCustomRouterContext,
	type UseResourceCustomContext,
} from '@atlassian/jira-resource-with-custom-router-context';
import { serviceDeskContextResource } from '@atlassian/jira-router-resources-service-desk-context';

const getServiceDeskContextResource = () => serviceDeskContextResource;

export const useServiceDeskContext = (
	projectKey?: string,
	customContext?: UseResourceCustomContext<PracticeQueueRouteParams>,
) => {
	const {
		data,
		loading,
		error,
		refresh: refreshCache,
		// TODO remove useInitFetchResource() wrapper on 'jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0' FF cleanup
	} = useInitFetchResource(
		useResourceWithCustomRouterContext(getServiceDeskContextResource(), customContext),
		ff('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'),
	);

	useEffect(() => {
		if (!__SERVER__) {
			refreshCache();
		}
	}, [projectKey, refreshCache]);

	return [{ data, loading, error }] as const;
};

export { USER_JSM_PROJECT_ROLE } from './constants';
